import React, { useContext, useEffect, useState } from "react";
import "./header.css";
import { BiMenuAltRight } from "react-icons/bi";
import { MdClose } from "react-icons/md";
import { RiHome4Line } from "react-icons/ri";
import { GrTechnology } from "react-icons/gr";
import { GiPathDistance, GiPhone } from "react-icons/gi";
import { Context } from "../Wrapper/Wrapper";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";
import { FormattedMessage } from "react-intl";

const Header = () => {
  const detectScroll = () => {
    window.scrollY > 2
      ? document.getElementsByTagName("header")[0].classList.add("scroll-active")
      : document.getElementsByTagName("header")[0].classList.remove("scroll-active");
  };

  const [open, setOpen] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", (e) => detectScroll());

    return () => {
      window.removeEventListener("scroll", (e) => detectScroll());
    };
  }, []);

  useEffect(() => {
    open ? (document.getElementsByTagName("body")[0].style.overflow = "hidden") : (document.getElementsByTagName("body")[0].style.overflow = "auto");
  }, [open]);

  const [drpOpen, setDrpOpen] = useState(false);

  const context = useContext(Context);

  const closeDrp = () => {
    setDrpOpen(false);
  };

  function changeLanguageAndCloseDrp(local: string) {
    context.changeLanguage(local);
    closeDrp();
  }
  return (
    <>
      <header>
        <nav className="container">
          <h3>NyN.</h3>
          <ul className="nav-right">
            <li>
              <a href="#home"><FormattedMessage id="header.home" defaultMessage="Home" /></a>
            </li>
            <li>
              <a href="#skills"><FormattedMessage id="header.skills" defaultMessage="Skills" /></a>
            </li>
            <li>
              <a href="#works"><FormattedMessage id="header.works" defaultMessage="Works" /></a>
            </li>
            <a href="#contact" className="contact-me">
              <FormattedMessage id="header.contact" defaultMessage="Contact me" />
            </a>
            <button className="menu-bar" onClick={() => setOpen(true)}>
              <BiMenuAltRight color="#f4d58d" size="2em" />
            </button>
            <li className="language" onClick={() => setDrpOpen((current) => !current)}>
              {context.locale} <MdOutlineKeyboardArrowDown size="1.3em" />
            </li>
            <div className={`dropdownLanguage ${drpOpen ? "show-drp" : ""}`}>
              <li onClick={() => changeLanguageAndCloseDrp("fr")}><FormattedMessage id="header.fr" defaultMessage="French" /></li>
              <li onClick={() => changeLanguageAndCloseDrp("en")}><FormattedMessage id="header.en" defaultMessage="English" /></li>
            </div>
          </ul>
        </nav>
      </header>
      <div className={`drawer ${open ? "active" : ""}`} onClick={() => setOpen(false)}>
        <button className="btnClose">
          <MdClose size="2em" />
        </button>
        <div className="head">
          <h3>NyN.</h3>
        </div>
        <div className="drawer-content">
          <ul>
            <li onClick={() => setOpen(false)}>
              <a href="#home">
                <RiHome4Line size="1.3em" />
                <FormattedMessage id="header.home" defaultMessage="Home" />
              </a>
            </li>
            <li onClick={() => setOpen(false)}>
              <a href="#techno">
                <GrTechnology size="1.3em" />
                <FormattedMessage id="header.skills" defaultMessage="Skills" />
              </a>
            </li>
            <li onClick={() => setOpen(false)}>
              <a href="#career">
                <GiPathDistance size="1.3em" />
                <FormattedMessage id="header.works" defaultMessage="Works" />
              </a>
            </li>
            <li className="responsive-btn-contact" onClick={() => setOpen(false)}>
              <a href="#contact">
                <GiPhone size="1.3em" />
                <FormattedMessage id="header.contact" defaultMessage="Contact me" />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Header;
